import { Flag, Gamepad2 } from 'lucide-react'
import { useEffect } from 'react'
import { PartyHome } from '../components/PartyHome'
import { useCreateAndEnter } from '../hooks/useCreateRoom'
import { LevelSelect } from '../ice/LevelSelect'
import { RaceCreatePanel } from '../ice/RaceCreatePanel'
import { api } from '../lib/api'
import { useSession } from '../store/session'

export function IceHome() {
  const load = useSession((s) => s.load)
  const { create, creating, error } = useCreateAndEnter(api.createIceRoom, '/ice/r')

  useEffect(() => {
    void load()
  }, [load])

  return (
    <PartyHome
      current="/ice"
      roomPath="/ice/r"
      create={{
        title: 'Race friends',
        tabLabel: 'Race',
        icon: <Flag className="size-5 lg:mr-1 lg:inline lg:size-4" aria-hidden />,
        panel: <RaceCreatePanel onCreate={create} creating={creating} error={error} />,
      }}
      join={{ id: 'ice-join-code', label: 'Have a race code?', title: 'Join a race' }}
      firstTab={() => ({
        key: 'solo',
        label: 'Solo',
        icon: <Gamepad2 className="size-5" aria-hidden />,
        onSelect: () => document.getElementById('solo')?.scrollIntoView({ behavior: 'smooth' }),
      })}
    >
      <section id="solo" aria-labelledby="solo-title" className="flex scroll-mt-20 flex-col gap-2">
        <h2 id="solo-title" className="text-sm font-bold uppercase tracking-wide text-slate-500">
          Solo levels
        </h2>
        <LevelSelect />
      </section>
    </PartyHome>
  )
}
